import React, { useState, useEffect } from 'react';
import classNames from 'classnames';

/**
 * is it replaceable with '@gx-design/loader'; ?
 * @typedef {Object} LoaderProps
 * @property {boolean} [loading]
 * @property {boolean} [fixedOverlay]
 * @property {boolean} [inlineOverlay]
 * @property {boolean} [centered]
 * @property {number} [delay]
 */

/**
 * @param {LoaderProps} props
 */
export const Loader = ({ loading, fixedOverlay = true, inlineOverlay = false, centered = true, delay = 350 }) => {
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        let timeout;

        if (!loading) {
            setIsLoading(loading);
        } else {
            timeout = setTimeout(() => setIsLoading(loading), delay);
        }

        return () => clearTimeout(timeout);
    }, [loading]);

    return isLoading ? (
        <div
            className={classNames('gx-loader-overlay', {
                'gx-loader-overlay--fixed': fixedOverlay,
                'gx-loader-overlay--inline': inlineOverlay,
            })}
        >
            <div className={classNames('gx-loader', { 'gx-loader--centered': centered })} />
        </div>
    ) : null;
};
